import React from "react";
import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Divider,
  Button,
  Card,
  CardContent,
  Fade,
} from "@mui/material";
import { Inbox, Mail } from "lucide-react";
import ReactPaginate from "react-paginate";
import { ChevronLeft, ChevronRight } from "lucide-react";
import LoadingPage from "../../Components/Common/Loading/LoadingPage";

export default function SidebarMailbox({
  loading,
  filter,
  setFilter,
  messages,
  pagination,
  openMessage,
  setSelected,
}) {
  return (
    <Box sx={{ width: "100%" }}>
      <Card
        // elevation={0}
        sx={{ height: "80%", overflow: "hidden", mb: "10px" }}>
        <CardContent sx={{ p: "5px 10px", overflow: "auto" }}>
          <Box display="flex" alignItems="center" gap={1} mb={2}>
            <Inbox />
            <Typography variant="h6">Buzón</Typography>
          </Box>

          <Button
            variant="outlined"
            color="secondary"
            fullWidth
            startIcon={<Mail />}
            sx={{ mb: 2 }}
            onClick={() => setSelected("compose")}>
            Nuevo mensaje
          </Button>

          <Divider sx={{ mb: 2 }} />

          <Button
            fullWidth
            variant={filter === "inbox" ? "contained" : "outlined"}
            color="info"
            sx={{ mb: 1 }}
            onClick={() => setFilter("inbox")}>
            Bandeja de entrada
          </Button>

          <Button
            fullWidth
            variant={filter === "sent" ? "contained" : "outlined"}
            color="success"
            sx={{ mb: 2 }}
            onClick={() => setFilter("sent")}>
            Enviados
          </Button>

          <Divider sx={{ mb: 1 }} />

          <Box flex={1} overflow="auto">
            {loading ? (
              <LoadingPage isLoading heightProp="40vh" />
            ) : (
              <Fade in={!loading} timeout={800}>
                <List disablePadding sx={{ maxHeight: "400px" }}>
                  {messages.length === 0 && (
                    <Box p={2}>
                      <Typography variant="body2" color="text.secondary">
                        No hay mensajes en esta vista.
                      </Typography>
                    </Box>
                  )}

                  {messages.map((msg) => (
                    <React.Fragment key={msg.id}>
                      <ListItem disablePadding sx={{ mb: 1 }}>
                        <ListItemButton
                          onClick={() => openMessage(msg)}
                          sx={{
                            backgroundColor:
                              msg.status === "unread" && filter !== "sent"
                                ? "rgba(25,118,210,.12)"
                                : "transparent",
                          }}>
                          <Card variant="outlined" sx={{ width: "100%" }}>
                            <CardContent>
                              <ListItemText
                                primary={`ASUNTO: ${(msg?.subject || "").toUpperCase()}`}
                                secondary={
                                  filter === "sent"
                                    ? `Para: ${msg.to_relation?.name} ${msg.to_relation?.surname}`
                                    : `De: ${msg.from_relation?.name} ${msg.from_relation?.surname}`
                                }
                              />
                            </CardContent>
                          </Card>
                        </ListItemButton>
                      </ListItem>
                      <Divider />
                    </React.Fragment>
                  ))}
                </List>
              </Fade>
            )}
          </Box>
        </CardContent>
      </Card>

      <Box sx={{ p: 2 }}>
        <ReactPaginate
          breakLabel="..."
          nextLabel={<ChevronRight size={18} />}
          previousLabel={<ChevronLeft size={18} />}
          pageCount={pagination.last_page || 1}
          forcePage={(pagination.page || 1) - 1}
          containerClassName="pagination"
          pageRangeDisplayed={2}
          marginPagesDisplayed={2}
        />
      </Box>
    </Box>
  );
}
